import React, {Component} from 'react';
import {FormControl, TextField, withStyles} from "@material-ui/core";
import {setArrayPath} from "../Utils/setArrayPath";
import findByString from "../Utils/getValueByString";
import {errorHandler} from "../Utils/errorHandler";
import FieldWrapper from "../FieldWrapper";
import InputMask from 'react-input-mask'
import FieldErrorMessage from "../Utils/errorMessage";
import {checkHidden} from "../Utils/checkHidden";

const styles = () => ({});

class DurationType extends Component {
    constructor(props) {
        super(props);
        this.fieldRef = React.createRef();
        this.state = {
            values: {},
            initialValue: '',
            fieldValue: '',
            errorComponent: false,
            changed: false,
            error: '',
            path: ''
        }
    }

    componentDidMount() {
        const {onBlurFromCell, field, focusNow} = this.props;

        if (focusNow && field.disabled) {
            onBlurFromCell();
        }
        if (focusNow) {
            if (this.fieldRef.current) {
                this.fieldRef.current.focus()
            }
        }
        this.setValues();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {values, errors} = this.props;
        const {values: prevValues, errors: prevErrors} = prevProps;
        if (values !== prevValues) {
            this.setValues();
        }
        if (errors !== prevErrors) {
            this.setErrors()
        }
    }

    componentDidCatch(error, errorInfo) {
        this.setState({errorComponent: true});
        console.log(error, errorInfo)
    }

    setValues = () => {
        const {values, field: {path, isArray}, containerArrayPath} = this.props;
        try {
            let arrayPath = setArrayPath(path, containerArrayPath);
            let value = findByString(values, arrayPath ? arrayPath : path);
            let currentValue = isArray ? value ? value : [] : value ? value : '';
            let initialValue = isArray ? currentValue.map((v, i) => {
                return {value: typeof v === 'object' ? v.value : v, idx: `${v}_${i}`}
            }) : currentValue;
            this.setState({values, initialValue, fieldValue: initialValue, path: arrayPath ? arrayPath : path})
        } catch (e) {
            console.log(e)
        }
    };
    setErrors = () => {
        const {path} = this.state;
        const {errors, containerArrayPath} = this.props;
        let errorField = errorHandler(errors, path, containerArrayPath);
        this.setState({error: errorField})
    };

    onChange = (event) => {
        const {value} = event.target;
        if (event.type === 'focus') return;
        this.setState({fieldValue: value, filterValue: value, changed: true})
    };
    onChangeFromDropDown = (value) => {
        const {field: {isArray}} = this.props;
        if (isArray) {
            this.setState(state => ({
                fieldValue: [...state.fieldValue, {value: value, idx: `${value}_${state.fieldValue.length + 1}`}],
                filterValue: '',
                changed: true,
            }));
            this.onBlur();
        } else {
            this.setState({fieldValue: value, filterValue: '', changed: true});
            this.onBlur();
        }
    };
    setInitialValue = () => {
        this.setState(state => ({fieldValue: state.initialValue, changed: false}))
    };

    onBlur = () => {
        const {fieldValue, changed, path} = this.state;
        const {field: {trackChange}, setValue, onBlurFromCell, focusNow} = this.props;
        if (changed) {
            let currentValue = fieldValue === '__:__:__.___' ? "" : fieldValue;
            setValue(currentValue, path, trackChange)
        }
        if (focusNow) {
            onBlurFromCell();
        }
        this.setState({changed: false})
    };

    render() {
        const {errorComponent, values, fieldValue, filterValue, changed, error, path} = this.state;
        const {
            classes,
            field: {
                disabled,
                pattern,
                label,
                required,
                autofocus,
                dropdown,
                hideCondition
            },
            fieldStyles,
            labelStyles,
            showLabel,
            goBack,
            focusNow,
            history,
            isMobile,
            globalValues,
            screenName
        } = this.props;
        const isHidden = checkHidden(globalValues, hideCondition);
        const isDisabled = checkHidden(globalValues, disabled);

        return (
            !errorComponent ? (
                    <FieldWrapper
                        isHidden={isHidden}
                        required={required}
                        dropdown={dropdown}
                        focusNow={focusNow}
                        record={values}
                        filterValue={filterValue}
                        path={path}
                        disabled={isDisabled}
                        changed={changed}
                        setValue={this.onChangeFromDropDown}
                        setInitialValue={this.setInitialValue}
                        fieldRef={this.fieldRef}
                        fieldStyles={fieldStyles}
                        labelStyles={labelStyles}
                        showLabel={showLabel}
                        label={label}
                        goBack={goBack}
                        history={history}
                        setFreeSolo={this.setFreeSolo}
                        isMobile={isMobile}
                        globalValues={globalValues}
                        screenName={screenName}
                    >
                        <FormControl classes={{root: classes.formControl}}
                                     fullWidth={isMobile ? true : fieldStyles.fullWidth}>
                            <DurationInput
                                fieldStyles={fieldStyles}
                                disabled={isDisabled}
                                fieldRef={this.fieldRef}
                                required={required}
                                fieldValue={fieldValue}
                                autofocus={autofocus}
                                error={error}
                                label={label}
                                pattern={pattern}
                                onChange={this.onChange}
                                onBlur={this.onBlur}
                                isMobile={isMobile}
                            />
                            <FieldErrorMessage message={error}/>
                        </FormControl>
                    </FieldWrapper>
                ) :
                (<span>Something bad with field</span>)
        );
    }

}

export default withStyles(styles)(DurationType)


const DurationInput = (props) => {
    const {
        fieldValue,
        onChange,
        onBlur,
        required,
        fieldStyles,
        pattern,
        disabled,
        autofocus,
        error,
        fieldRef,
        label,
        isMobile
    } = props;
    const inputClassName = fieldStyles.withoutStyles ? 'horizontal-fields-table' : 'form-dynamic-default';
    const fieldPresentation = fieldStyles.presentation ? fieldStyles.presentation === 'inlineWithLabel' ? 'standard' : fieldStyles.presentation : 'outlined'
    const customStyles = (isMobile || fieldStyles.presentation === 'standard') ? {
            marginTop: 4
        } :
        {
            flex: '1 1 auto',
            display: 'block',
            outline: '1px',
            height: !isMobile && 25,
            paddingTop: !isMobile && 3,
            paddingLeft: !isMobile && 2,
        };
    return (
        <InputMask
            mask="99:99:99.999"
            placeholder={"hh:mm:ss.SSS"}
            value={fieldValue}
            onChange={onChange}
            onBlur={onBlur}
            disabled={disabled}
        >
            {(inputProps) => <TextField
                {...{
                    ...inputProps,
                    label: (isMobile || fieldStyles.presentation === 'standard') && label,
                    disabled: disabled,
                    variant: isMobile ? 'standard' : fieldPresentation,
                    fullWidth: isMobile ? true : fieldStyles.fullWidth,
                    error: error.length > 0,
                    inputRef: fieldRef,
                    autoFocus: autofocus,
                    required: required,
                    className: inputClassName,
                    style: customStyles

                }}
                required={required}
                inputProps={{
                    style: {width: !props.isMobile && fieldStyles.width, height: fieldStyles.height},
                    pattern: pattern,
                    className: !fieldStyles.withoutStyles && 'with-styles',
                }}
            />}
        </InputMask>
    )
};